import type { TDealRiskLevel } from 'types/deals';

export const DEAL_RISK_SCORE_BANDS: Record<
  TDealRiskLevel,
  { min: number; max: number }
> = {
  low: { min: 0, max: 33 },
  medium: { min: 34, max: 66 },
  high: { min: 67, max: 100 }
};

// Takes a finite number; callers keep their own guards for missing or
// non-numeric scores. Scores can be fractional but are shown as whole numbers,
// so the band is picked from the rounded score: a deal shown as 33 sits in the
// 0-33 band the labels advertise.
export const getDealRiskBandFromScore = (score: number): TDealRiskLevel => {
  const displayedScore = Math.round(score);

  if (displayedScore <= DEAL_RISK_SCORE_BANDS.low.max) {
    return 'low';
  }

  if (displayedScore <= DEAL_RISK_SCORE_BANDS.medium.max) {
    return 'medium';
  }

  return 'high';
};

export const formatDealRiskBandRange = (band: TDealRiskLevel) =>
  `${DEAL_RISK_SCORE_BANDS[band].min}-${DEAL_RISK_SCORE_BANDS[band].max}`;
